import NotesIcon from "@mui/icons-material/Notes";

export const ActionLogsText = (
  <>
    <NotesIcon fontSize="small" />
    &nbsp;Action Logs
  </>
);
